module.exports = "<button class=\"btn btn-primary\"\r\n        (click)=\"this.logout()\">Logout</button>"